import { AllowedFlags } from 'hooks/useFeatures';

export enum Unread {
  message = 'message',
  lead = 'lead',
}

export type UnreadType = keyof typeof Unread;

export interface Item {
  path: string;
  labelKey: string;
  unreadType?: UnreadType;
  allowedToRender?: (props: AllowedFlags) => boolean;
  badge?: {
    labelKey: string;
  };
}

interface DynamicNavigationItemProps {
  isVisible: boolean;
  path: string;
}

export interface DynamicNavigationItems {
  assist?: DynamicNavigationItemProps;
}

export interface NavigationProps {
  navItems: Item[];
  dropdownItems: Item[];
  dropdownSecondaryItems?: Item[];
}
